import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from "react-router-dom";
import { Button, Carousel, Col, Image, Row, Tabs } from 'antd';
import { ApartmentOutlined, FileDoneOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import {  useSelector } from 'react-redux';
import { DefaultScreen } from './DefaultScreen';
import styles from "./styles/ClientScreen.module.css"
import { Calendar } from '../PropertyComp/components/Calendar';
import { Help } from '../App/components/Help';
import { Tasks } from '../PropertyComp/components/Tasks';
const { TabPane } = Tabs;

export default function ClientScreen() {
 
  const [activeTab, setActiveTab] = useState('dashboard');
  const [activeSubTab, setActiveSubTab] = useState("1");
  const { getUserDetailsData } = useSelector((state) => state.account);
  const location = useLocation();
  const source = location.state?.source;
  const ref = useRef();
  // Added for reference for Task component >> Later can be removed
  const [state, setState] = useState({
    customModalVisible: false,
    editToggle: false,
    status: false,
    editClickedData: {},
    taskId: "",
  });

  useEffect(() => {
    if (source === "SHARE_CALENDAR") {
      setActiveTab("taskCalendar");
    }
  }, [])
  
  return (
    <div >
      <Row
        gutter={[4, 4]}
        style={{
          // marginLeft: "unset",
          marginRight: "5px",
          marginTop: "10px",
          marginLeft: "5px",
          // width: "100%",
          overflowX:"hidden"
         
        }}
      >
        <Col
          span={24}
          xs={24}
          sm={24}
          md={24}
          lg={7}
          xl={6}
          
        >
        <div 
        style={{
            boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            borderRadius: "8px",
           width:"100%",
            border: "1px solid  rgba(0,0,0,0.2)",
          padding:"0.5rem",
          height:"100%"
          }}>
          <div
           className={styles.firsttab}
          >
             {getUserDetailsData?.propertyData?.propertyImages?.length > 0 && (
                <Carousel draggable dots dotPosition="bottom" effect="fade" ref={ref}>
                  {getUserDetailsData?.propertyData?.propertyImages.map((el, index) => (
                    <div key={index} style={{ position: "relative" }}>
                      <Image width={"100%"} height={150} src={el?.imageUrl} alt={`property-${index}`} style={{ objectFit: "cover" }} />
                      <div style={{ position: "absolute", top: "35%", left: "5px" }}>
                        {index !== 0 && (
                          <Button
                            type="ghost"
                            size="small"
                            style={{
                              border: "none",
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              borderRadius: "5px",
                            }}
                            onClick={() => ref.current.prev()}
                            icon={
                              <LeftOutlined
                                style={{
                                  fontWeight: "bolder",
                                  fontSize: "15px",
                                  color: "#3A74B6",
                                  strokeWidth: "50",
                                  stroke: "#3A74B6",
                                }}
                              />
                            }
                          />
                        )}
                      </div>
                      <div style={{ position: "absolute", top: "35%", right: "5px" }}>
                        {index !== getUserDetailsData?.propertyData?.propertyImages.length - 1 && (
                          <Button
                            type="ghost"
                            size="small"
                            style={{
                              border: "none",
                              backgroundColor: "rgba(255, 255, 255, 0.7)",
                              borderRadius: "5px",
                            }}
                            onClick={() => ref.current.next()}
                            icon={
                              <RightOutlined
                                style={{
                                  fontWeight: "bolder",
                                  fontSize: "15px",
                                  color: "#3A74B6",
                                  strokeWidth: "50",
                                  stroke: "#3A74B6",
                                }}
                              />
                            }
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </Carousel>
              )}
            {getUserDetailsData?.propertyData?.address}
          </div>

          {/* Dashboard Tab */}
          <div
            className="modal_row"
            style={{
              marginTop: "3px",
              marginBottom: "14px",
              backgroundColor: activeTab === 'dashboard' ? "#96c8f6" : "transparent",
              marginRight: "23px",
              borderRadius: "5px",
              color: activeTab === 'dashboard' ? "#085191" : "grey",
              // pointerEvents: (!getUserDetailsData?.builtForSection || getUserDetailsData?.builtForSection !== "SHARE_CALENDAR") ? "all" : "none"
            }}
            onClick={() => setActiveTab('dashboard')}
          >
            <div className="icon_div">
              <FileDoneOutlined style={{ fontSize: "22px", color: "black" }} />
            </div>
            <div className="content_div">
              <p style={{ marginLeft: "20px" }}>Dashboard</p>
            </div>
          </div>
            
           {/* Task/Calendar Tab */}
            <div className="modal_row"
              style={{
                backgroundColor: activeTab === 'taskCalendar' ? "#96c8f6" : "transparent",
                marginRight: "23px",
                borderRadius: "5px",
                color: activeTab === 'taskCalendar' ? "#085191" : "grey",
                // pointerEvents: (!getUserDetailsData?.builtForSection || getUserDetailsData?.builtForSection !== "SHARE_CALENDAR") ? "none" : "all"
              }}
              onClick={() => setActiveTab('taskCalendar')}
            >
              <div className="icon_div">
                <ApartmentOutlined style={{ fontSize: "22px", color: "black" }} />
              </div>
              <div className="content_div">
                <p style={{ marginLeft: "20px" }}>Task/Calendar</p>
              </div>
            </div>
          </div>
        </Col>
        <Col span={24} xs={24} sm={24} md={24} lg={17} xl={18}>
          <div className="OfferTopContainer" style={{ height: "calc(100vh - 4.4rem)", padding: "0.5rem", overflowY: "hidden",
           boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", borderRadius: "8px", width: "100%", border: "1px solid  rgba(0,0,0,0.2)", paddingBottom: "2rem" }}>
            {activeTab === 'dashboard' && <DefaultScreen />}
            {activeTab === 'taskCalendar' &&
              <div>
                <Tabs activeKey={activeSubTab} centered onChange={(key) => setActiveSubTab(key)}
                  tabBarExtraContent={<div style={{ margin: "5px 5px 0 0" }}><Help tabName="CLIENT_SCREEN" /></div>}
                >
                  <TabPane tab={<div>Calendar</div>} key="1" style={{ width: "100%", height: "100%", fontSize: "10px" }}>
                    <Calendar  key={activeSubTab} agentType={getUserDetailsData?.openFor} viewType={'month'} screen={"CLIENT_SCREEN"} offerId={getUserDetailsData?.offerId} clientToken={localStorage.getItem('clientAuth') || localStorage.getItem('clientToken')} />
                  </TabPane>
                  <TabPane tab={<div>Task</div>} key="2" style={{ width: "100%", height: "100%" }}>
                    <Tasks  key={activeSubTab} state={state} setState={setState} agentType={getUserDetailsData?.openFor} section={"CLIENT_SCREEN"} offerId={getUserDetailsData?.offerId} token={localStorage.getItem('clientAuth')}/>
                  </TabPane>
                </Tabs>
              </div>
            }
          </div>
        </Col>
      </Row>
    </div>
  );
}
